import React from "react";

export const Field = ({ label, children }) => (
  <label className="block">
    <span className="mb-1.5 block text-xs font-bold uppercase tracking-wide text-gray-500">
      {label}
    </span>
    {children}
  </label>
);

export const inputClass =
  "w-full rounded-xl border border-gray-200 bg-white px-3 py-2.5 text-sm font-semibold text-gray-800 outline-none transition focus:border-primary-400 focus:ring-2 focus:ring-primary-100";

export const SelectField = ({ value, onChange, children, required = true }) => (
  <select
    value={value}
    onChange={onChange}
    required={required}
    className={inputClass}
  >
    {children}
  </select>
);
